jQuery(document).ready(function ($) {

    (function () {

        var quotes = $(".CustomHero .quotes");
        var quoteIndex = -1;

        function showNextQuote() {
            ++quoteIndex;
            quotes.eq(quoteIndex % quotes.length)
                .fadeIn(1300)
                .delay(1300)
                .fadeOut(1300, showNextQuote);
        }

        showNextQuote();
    })();

    const animationRemote = bodymovin.loadAnimation({
        container: document.getElementById('svg__00'),
        path: '/wp-content/themes/beaverwarrior/components/CustomHero/bw-custom-hero/includes/img/IconFinalSize_optimized.json',
        autoplay: true,
        renderer: 'svg',
        loop: true
    });

});
